import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IDoaSubCategory } from '../../../interface/administrator/admin';
import { ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/administrator/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { AddUpdateDialogComponent } from './add-update-dialog/add-update-dialog/add-update-dialog.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
import { ConfirmdialogComponent } from '../../../shared/component/confirmdialog/confirmdialog.component';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-doa-sub-categories',
  imports: [CommonModule,MaterialModule],
  templateUrl: './doa-sub-categories.component.html',
  styleUrl: './doa-sub-categories.component.css'
})
export class DoaSubCategoriesComponent implements OnInit, AfterViewInit {
  title = 'DOA Sub Category Setup';
  isLoading:boolean=false;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  DisplayedColumns: string[] = [
    'serialNo',
    'subCatCode',
    'subCatName',
    'subCatNote',
    'actions'
  ];
  excelData:any;

  dataSource = new MatTableDataSource<IDoaSubCategory>();
  constructor(private http: HttpClient,  private sharedService:SharedServices, private adminservice: AdminService, public dialog: MatDialog) { }
  ngOnInit(): void {
    this.isLoading = true;
    this.getDoaSubCategory();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getDoaSubCategory(): Observable<IDoaSubCategory[]> {
    this.adminservice.getDoaSubCategory()
      .subscribe((data: IDoaSubCategory[]) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.excelData = data.map((item, index) => ({
          ...item,
          'S/No': index + 1,
          'Sub Category Code': item.subCatCode ?? '',
          'Sub Category Name': item.subCatName ?? '',
          'Note': item.subCatNote ?? ''
        }));
        this.isLoading = false;
        this.isLoading = false;
      }, error => {
        console.error('Error fetching categories', error);
        this.isLoading = false;
      });
      return this.adminservice.getDoaSubCategory(); 
  }
  openAddDialog(): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '430px',
      data: { isEdit: false, existingSubCategories: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getDoaSubCategory();
    });
  }
  
  openUpdateDialog(element: IDoaSubCategory): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '430px',
      data: { isEdit: true, user: element, existingSubCategories: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getDoaSubCategory();
    });
  }
   removeSubCategory(element: IDoaSubCategory): void {
        const dialogRef = this.dialog.open(ConfirmdialogComponent, {
          width: 'auto',
          position: { top: '1'},
        data: { message: 'Are you sure you want to delete the sub category?' }
        });
      
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.isLoading = true;
            this.adminservice.deleteDoaSubCategory(element.id).subscribe({
              next: response => {
                this.getDoaSubCategory().subscribe({
                  next: () => {
                    this.sharedService.openModal('Message', 'Removed Successfully');
                    this.isLoading = false;
                  },
                  error: error => {
                    console.error('Error fetching categories', error);
                    this.isLoading = false;
                  }
                });
              },
              error: error => {
                console.error('Error removing sub category', error);
                this.isLoading = false;
              }
            });
          }
        });
      }

  
  applyFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: IDoaSubCategory, filter: string) => {
      const filters = JSON.parse(filter);
      return Object.keys(filters).every(key => {
        const textToSearch = data[key as keyof IDoaSubCategory] && data[key as keyof IDoaSubCategory].toString().toLowerCase() || '';
        return textToSearch.indexOf(filters[key]) !== -1;
      });
    };
  
    const currentFilters = this.dataSource.filter ? JSON.parse(this.dataSource.filter) : {};
    currentFilters[column] = filterValue;
    this.dataSource.filter = JSON.stringify(currentFilters);
  
    const filteredData = this.dataSource.filteredData.map((item, index) => ({
      ...item,
      'S/No': index + 1,
      'Sub Category Code': item.subCatCode ?? '',
      'Sub Category Name': item.subCatName ?? '',
      'Note': item.subCatNote ?? ''
    }));
    this.excelData = filteredData;
  }
 
  downloadExcel(): void {
    this.adminservice.getSubCategoriesWorksheet(this.excelData).subscribe(
      (data:Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `SubCategories_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
 
  }
 
 
}
 
